
var Vouchers = function()
{

	var createContainer = $('[data-javascript="create-vouchers"]');

	var rulesContainer = $('[data-javascript="create-rules"]');

	var resultsContainer = $('[data-javascript="create-results"]');

	/**
	 * [generateSelect description]
	 * @param  {[type]} name [description]
	 * @param  {[type]} data [description]
	 * @return {[type]}      [description]
	 */
	var generateSelect = function( name, data, attributes )
	{
		attributes = attributes || {};
		var select = $('<select />').attr('name', name);
		for( var attr in attributes ) {
			select.attr( attr, attributes[attr] );
		}
		for( var index in data )
		{
			var option = $('<option />').val(index).text(data[index]);
			option.appendTo(select);
		}
		return select;
	};

	/**
	 * [generateTextInput description]
	 * @param  {[type]} name       [description]
	 * @param  {[type]} value      [description]
	 * @param  {[type]} attributes [description]
	 * @return {[type]}            [description]
	 */
	var generateTextInput = function( name, value, attributes )
	{
		attributes = attributes || {};
		var input = $( '<input />' ).attr( 'type', 'text' ).attr( 'name', name );
		for( var attr in attributes ) {
			input.attr( attr, attributes[attr] );
		}
		return input;
	};

	/**
	 * [getAttributes description]
	 * @param  {[type]} node [description]
	 * @return {[type]}      [description]
	 */
	var getAttributes = function( node )
	{
		var attributes = {};
		for( var i in node.attributes ) {
			if( node.attributes.hasOwnProperty( i ) ) {
				attributes[node.attributes[i].name] = node.attributes[i].nodeValue;
			}
		}
		return attributes;
	};



	/**
	 * [CreateRules description]
	 */
	var CreateRules = function()
	{

		/**
		 * [tbody description]
		 * @type {[type]}
		 */
		var tbody = $('[data-for="voucher-rules-list"]');

		/**
		 * [addRuleToList description]
		 * @param {[type]} response   [description]
		 * @param {[type]} attributes [description]
		 * @param {[type]} modal      [description]
		 */
		var addRuleToList = function( model, attributes, modal )
		{
			$('[data-for="no-voucher-rules"]', tbody).remove();
			modal.semanticUiModal( 'hide' );
			var row = $('<tr />').attr( 'data-rule-row-id', model.id );
			$( '<td />' ).text( model.id ).appendTo( row );
			$( '<td />' ).text( model.operator ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'type' ).text( model.type ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'item' ).text( model.item ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="btn-group" />');

			var orRuleButton = $('<a data-for="create-or-rule" class="btn btn-default btn-sm"><i class="fa fa-compress"></i></a>').attr('href', model.or_rule_url);
			var editButton = $('<a data-for="edit-rule" class="btn btn-default btn-sm"><i class="fa fa-pencil-square-o"></i></a>').attr('href', model.edit_url);
			var deleteButton = $('<a data-for="delete-rule" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>').attr('href', model.delete_url).attr('data-id', model.id);

			orRuleButton.appendTo(buttons);
			editButton.appendTo(buttons);
			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);
			bindEvents();

		};

		/**
		 * [addOrRuleToList description]
		 * @param {[type]} response   [description]
		 * @param {[type]} attributes [description]
		 * @param {[type]} modal      [description]
		 */
		var addOrRuleToList = function( model, attributes, modal )
		{
			modal.semanticUiModal( 'hide' );
			var relatedRule = $('[data-rule-row-id="' + model.rule_id + '"]');
			var row = $('<tr />').attr( 'data-or-rule-row-id', model.id ).addClass('warning');
			$( '<td />' ).text( model.id ).appendTo( row );
			$( '<td />' ).html( '<i style="position:relative; transform: rotate(90deg);" class="ui level up icon"></i>' + model.operator ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'type' ).text( model.type ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'item' ).text( model.item ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="btn-group" />');
			var editButton = $('<a data-for="edit-or-rule" class="btn btn-success btn-sm"><i class="fa fa-pencil-square-o"></i></a>').attr('href', model.edit_url);
			var deleteButton = $('<a data-for="delete-or-rule" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>').attr('href', model.delete_url).attr('data-id', model.id);

			editButton.appendTo(buttons);
			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.insertAfter( relatedRule );

			bindEvents();
		};

		/**
		 * [updateRuleInList description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateRuleInList = function( model, attributes, modal )
		{
			modal.semanticUiModal( 'hide' );
			var row = $( '[data-rule-row-id="' + model.id + '"]', tbody );
			$('[data-for="type"]', row).text( model.type );
			$('[data-for="item"]', row).text( model.item );
		};

		/**
		 * [updateOrRuleInList description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateOrRuleInList = function( model, attributes, modal )
		{
			modal.semanticUiModal( 'hide' );
			var row = $( '[data-or-rule-row-id="' + model.id + '"]', tbody );
			$('[data-for="type"]', row).text( model.type );
			$('[data-for="item"]', row).text( model.item );
		};

		/**
		 * [removeRuleFromList description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		var removeRuleFromList = function( response, attributes )
		{
			$( '[data-rule-row-id="' + attributes['data-id'] + '"]', tbody ).fadeOut( 200, function(){
				$(this).remove();
				if( ! $('tr', tbody ).length ) {
					var noRules = $('<tr />').attr( 'data-for', 'no-voucher-rules' );
					$('<td />')
						.attr( 'colspan', 5 )
						.text( 'You currently have no rules setup for this voucher.' )
						.appendTo( noRules );
					noRules.appendTo( tbody );
				}
			});
		};

		/**
		 * [removeOrRuleFromList description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		var removeOrRuleFromList = function( response, attributes )
		{
			$( '[data-or-rule-row-id="' + attributes['data-id'] + '"]', tbody ).fadeOut( 200, function(){
				$(this).remove();
				if( ! $('tr', tbody ).length ) {
					var noRules = $('<tr />').attr( 'data-for', 'no-voucher-rules' );
					$('<td />')
						.attr( 'colspan', 5 )
						.text( 'You currently have no rules setup for this voucher.' )
						.appendTo( noRules );
					noRules.appendTo( tbody );
				}
			});
		};

		/**
		 * [whenCreateRuleIsVisible description]
		 * @param  {[type]} modalObj [description]
		 * @return {[type]}          [description]
		 */
		var whenCreateRuleIsVisible = function( modalObj )
		{
			var createForm = $('form', modalObj);
			var ruleType = $('#rule-type', modalObj);
			var selectWrapper = $('#generated-select', modalObj);

			ruleType.change( function(){
				createForm.addClass( 'loading' );
				selectWrapper.html('');

				var formElm = $('<div />').addClass( 'item form-group' );
				var formElmCol = $('<div />').addClass( 'col-md-6 col-sm-6 col-xs-12' );

				switch( parseInt($(this).val()) )
				{
					case 1 :
						$.get( $( '#get-categories-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );
							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Category:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Category' ).prependTo( select );
							select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
						});
					break;
					case 2 :
						$.get( $( '#get-categories-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );
							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Category:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Category' ).prependTo( select );
							select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
						});
					break;
					case 3 :
						$.get( $( '#get-products-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );
							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Product:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Product' ).prependTo( select );
							select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
						});
					break;
					case 4 :
						createForm.removeClass( 'loading' );
						$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Amount (excluding VAT):').appendTo( formElm );
						var input = generateTextInput( 'value', 0.00, { class : 'form-control' } );
						input.appendTo( formElmCol );
                        formElmCol.appendTo( formElm );
                        formElm.appendTo( selectWrapper );
					break;
					case 5 :
						$.get( $( '#get-product-types-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );
							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Product Type:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Product Type' ).prependTo( select );
							select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
						});
					break;
				}
			});
		};

		/**
		 * [createOrRuleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var createOrRuleHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenCreateRuleIsVisible,
				onComplete : addOrRuleToList
			});
		};

		/**
		 * [editRuleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editRuleHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenCreateRuleIsVisible,
				onComplete : updateRuleInList
			});
		};

		/**
		 * [editOrRuleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editOrRuleHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenCreateRuleIsVisible,
				onComplete : updateOrRuleInList
			});
		};

		/**
		 * [deleteRuleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteRuleHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : removeRuleFromList
			});
		};

		/**
		 * [deleteOrRuleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteOrRuleHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : removeOrRuleFromList
			});
		};

		/**
		 * [createRuleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var createRuleHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenCreateRuleIsVisible,
				onComplete : addRuleToList
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$('[data-for="create-rule"]').unbind( 'click' ).bind( 'click', createRuleHandler );
			$('[data-for="create-or-rule"]').unbind( 'click' ).bind( 'click', createOrRuleHandler );
			$('[data-for="edit-rule"]').unbind( 'click' ).bind( 'click', editRuleHandler );
			$('[data-for="delete-rule"]').unbind( 'click' ).bind( 'click', deleteRuleHandler );
			$('[data-for="delete-or-rule"]').unbind( 'click' ).bind( 'click', deleteOrRuleHandler );
			$('[data-for="edit-or-rule"]').unbind( 'click' ).bind( 'click', editOrRuleHandler );
		};

		bindEvents();
	};

	/**
	 * [CreateVoucher description]
	 */
	var CreateVoucher = function()
	{

		/**
		 * [datepicker description]
		 * @return {[type]} [description]
		 */
		var datepicker = function()
		{
			$('.datepicker').pickadate({
				formatSubmit: 'yyyy-mm-dd'
			});
		};

		/**
		 * [voucherTypeChangeHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var voucherTypeChangeHandler = function(e)
		{
			$('#code-field').hide();
			if( $(this).val() === '1' ) {
				$('#code-field').show();
				$('#code-field input').val('');
			}
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			datepicker();
			$('#voucher-type').change( voucherTypeChangeHandler );
		};

		bindEvents();

	};

	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function()
	{
		if( createContainer.length ) {
			new CreateVoucher();
		}
		if( rulesContainer.length ) {
			new CreateRules();
		}
		if( resultsContainer.length ) {
			new CreateResults();
		}
	};

	/**
	 * [CreateResults description]
	 */
	var CreateResults = function()
	{

		/**
		 * [tbody description]
		 * @type {[type]}
		 */
		var tbody = $('[data-for="results-list"]');

		/**
		 * [whenCreateRusultIsVisible description]
		 * @param  {[type]} modalObj [description]
		 * @return {[type]}          [description]
		 */
		var whenCreateRusultIsVisible = function( modalObj )
		{
			var createForm = $('form', modalObj);
			var ruleType = $('#result-type', modalObj);
			var selectWrapper = $('#generated-select', modalObj);
			var errorContainer = $('[data-for="error-wrapper"]', modalObj);

			ruleType.change( function(){
				createForm.addClass( 'loading' );
				selectWrapper.html('');
				errorContainer.html('');
				modalObj.semanticUiModal('refresh');

                var formElm = $('<div />').addClass( 'item form-group' );
                var formElmCol = $('<div />').addClass( 'col-md-6 col-sm-6 col-xs-12' );

				switch( parseInt( $(this).val() ) )
				{
					case 1 :
						/** Receive said FREE product */
						$.get( $( '#get-products-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );
							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Product:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Product' ).prependTo( select );
                            select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
							modalObj.semanticUiModal('refresh');
						});
					break;
					case 2 :
						/** Get said amount discount off cart total */
						createForm.removeClass( 'loading' );
						$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Amount (excluding VAT):').appendTo( selectWrapper );
						var input = generateTextInput( 'value', 0.00, { class : 'form-control' } );
                        input.appendTo( formElmCol );
                        formElmCol.appendTo( formElm );
                        formElm.appendTo( selectWrapper );
						modalObj.semanticUiModal('refresh');
					break;
					case 3 :
						/** Get said percentage discount off cart total */
						createForm.removeClass( 'loading' );
						$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Percentage:').appendTo( selectWrapper );
						var input = generateTextInput( 'value', 0.00, { class : 'form-control' } );
                        input.appendTo( formElmCol );
                        formElmCol.appendTo( formElm );
                        formElm.appendTo( selectWrapper );
						modalObj.semanticUiModal('refresh');
					break;
					case 4 :
						/** Get 1 said product free of charge (must be in cart) */
						$.get( $( '#get-products-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );
							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Product:').appendTo( selectWrapper );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Product' ).prependTo( select );
                            select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
							modalObj.semanticUiModal('refresh');
						});
					break;
					case 5 :
						/** Receive FREE delivery */
						createForm.removeClass( 'loading' );
						modalObj.semanticUiModal('refresh');
					break;
					case 6 :
						/** Get said percentage discount off every product in said category */
						$.get( $( '#get-categories-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );

							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Category:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Category' ).prependTo( select );
                            select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );

							formElm = $('<div />').addClass( 'item form-group' );
                            formElmCol = $('<div />').addClass( 'col-md-6 col-sm-6 col-xs-12' );

							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Percentage:').appendTo( formElm );
							var input = generateTextInput( 'value', 0.00, { class : 'form-control' } );
                            input.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
							modalObj.semanticUiModal('refresh');
						});
					break;
					case 7 :
						/** Get said amount discount off every product in said category */
						$.get( $( '#get-categories-route', modalObj ).val(), function( response ) {
							createForm.removeClass( 'loading' );

							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Category:').appendTo( formElm );
							var select = generateSelect( 'item_id', response, { class : 'form-control' } );
							$('<option />').val('').text( 'Please select a Category' ).prependTo( select );
                            select.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );

                            formElm = $('<div />').addClass( 'item form-group' );
                            formElmCol = $('<div />').addClass( 'col-md-6 col-sm-6 col-xs-12' );

							$('<label />').addClass( 'control-label col-md-3 col-sm-3 col-xs-12' ).text('Amount (excluding VAT):').appendTo( formElm );
							var input = generateTextInput( 'value', 0.00, { class : 'form-control' } );
                            input.appendTo( formElmCol );
                            formElmCol.appendTo( formElm );
                            formElm.appendTo( selectWrapper );
							modalObj.semanticUiModal('refresh');
						});
					break;
					default :
						createForm.removeClass( 'loading' );
					break;
				}

			});
		};

		/**
		 * [addResultToList description]
		 * @param {[type]} model      [description]
		 * @param {[type]} attributes [description]
		 * @param {[type]} modal      [description]
		 */
		var addResultToList = function( model, attributes, modal )
		{
			modal.semanticUiModal( 'hide' );
			$('[data-for="no-results"]').remove();

			var row = $('<tr />').attr( 'data-result-row-id', model.id );
			$( '<td />' ).text( model.id ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'type' ).text( model.type ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'item' ).text( model.item ).appendTo( row );
			$( '<td />' ).attr( 'data-for', 'value' ).text( model.value ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="btn-group" />');

			var editButton = $('<a data-for="edit-result" class="btn btn-default btn-sm"><i class="fa fa-pencil-square-o"></i></a>').attr( 'href', model.edit_url );
			var deleteButton = $('<a data-for="delete-result" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>').attr( 'href', model.delete_url ).attr( 'data-id', model.id );

			editButton.appendTo(buttons);
			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo( tbody );

			bindEvents();
		};

		/**
		 * [updateResultInList description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateResultInList = function( model, attributes, modal )
		{
			var row = $( '[data-result-row-id="' + model.id + '"]', tbody );
			$('[data-for="type"]', row).text( model.type );
			$('[data-for="item"]', row).text( model.item );
			$('[data-for="value"]', row).text( model.value );
			modal.semanticUiModal( 'hide' );
		};

		/**
		 * [removeResultFromList description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var removeResultFromList = function( model, attributes, modal )
		{
			$( '[data-result-row-id="' + model.id + '"]', tbody ).fadeOut( 200, function(){
				$(this).remove();
				if( ! $('tr', tbody ).length ) {
					var noResults = $('<tr />').attr( 'data-for', 'no-results' );
					$('<td />')
						.attr( 'colspan', 5 )
						.text( 'You currently have no results created.' )
						.appendTo( noResults );
					noResults.appendTo( tbody );
				}
			});
		};

		/**
		 * [createResultHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var createResultHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenCreateRusultIsVisible,
				onComplete : addResultToList
			});
		};

		/**
		 * [editResultHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editResultHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : whenCreateRusultIsVisible,
				onComplete : updateResultInList
			});
		};

		/**
		 * [deleteResultHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteResultHandler = function(e)
		{
			e.preventDefault();
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : removeResultFromList
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$('[data-for="create-result"]').unbind( 'click' ).bind( 'click', createResultHandler );
			$('[data-for="edit-result"]').unbind( 'click' ).bind( 'click', editResultHandler );
			$('[data-for="delete-result"]').unbind( 'click' ).bind( 'click', deleteResultHandler );
		};

		bindEvents();
	};

};

jQuery(document).ready( function($){

	var vouchers = new Vouchers();
	vouchers.init();

});
